export const DOP_CONFIG = {
    standards: [
        {
            value: 'EN_14509_2014',
            label: 'BAS EN 14509:2014',
            steps: ['zaglavlje', 'debljine', 'karakteristike']
        },
        {
            value: 'EN_13165_2017',
            label: 'BAS EN 13165+A2:2017',
            steps: ['zaglavlje', 'debljine', 'karakteristike']
        }
    ],

    izolacija: [
        { value: 'RW', label: 'RW' },
        { value: 'PIR', label: 'PIR' },
        { value: 'PUR', label: 'PUR' }
    ],

    performanceClass: ['NPD','A1','A2','B','C','D','E','F'],
    smoke: ['', 'NPD','s1','s2','s3'],
    droplets: ['', 'NPD','d0','d1','d2','d3'],

    fireResistance: {
        enabled: ['Da','Ne'],
        type: ['REI','EI'],
        minutes: [15,20,30,45,60,90,120,150,180,240]
    },

    debljineLim: [0.30,0.35,0.40,0.45,0.50,0.55,0.60,0.65,0.70],

    debljinePanel: [10,30,40,50,60,70,80,90,100,120,150,172, 180,250],

    notifiedBodies: [
        'NB 1395: Fires S.R.O. Slovakia',
        'NB 1376: ZAG Slovenija'
    ],

    dokumentacija: [
        'Nije relevantno',
        'Dokument o europskom tehničkom ocjenjivanju'
    ],


};

export const KARAKTERISTIKE_14509 = [

    // VI

    {
        key: 'u_value',
        translationKey: 'u_value'
    },

    // VII

    {
        key: 'lambda',
        translationKey: 'lambda'
    },

    // VIII GROUP

    {
        translationKey: 'mechanical_resistance',
        isGroup: true
    },

    {
        key: 'zatezna_cvrstoca',
        translationKey: 'zatezna_cvrstoca'
    },

    {
        key: 'modul_zatezanja',
        translationKey: 'modul_zatezanja'
    },

    {
        key: 'zatezna_temp',
        translationKey: 'zatezna_temp'
    },

    {
        key: 'modul_temp',
        translationKey: 'modul_temp'
    },

    {
        key: 'pritisna',
        translationKey: 'pritisna'
    },

    {
        key: 'modul_pritiska',
        translationKey: 'modul_pritiska'
    },

    {
        key: 'smicanje',
        translationKey: 'smicanje'
    },

    {
        key: 'smicanje_dugotrajno',
        translationKey: 'smicanje_dugotrajno'
    },

    {
        key: 'modul_smicanja',
        translationKey: 'modul_smicanja'
    },

    {
        key: 'puzanje_2000',
        translationKey: 'puzanje_2000'
    },

    {
        key: 'puzanje_100000',
        translationKey: 'puzanje_100000'
    },

    // l GROUP

    {
        translationKey: 'l_group',
        isGroup: true
    },

    {
        key: 'l_pozitivno',
        translationKey: 'l_pozitivno'
    },

    {
        key: 'l_pozitivno_temp',
        translationKey: 'l_pozitivno_temp'
    },

    {
        key: 'l_negativno',
        translationKey: 'l_negativno'
    },

    {
        key: 'l_negativno_temp',
        translationKey: 'l_negativno_temp'
    },

    // m GROUP

    {
        translationKey: 'm_group',
        isGroup: true
    },

    {
        key: 'm_kapacitet',
        translationKey: 'm_kapacitet'
    },

    {
        key: 'm_pozitivno',
        translationKey: 'm_pozitivno'
    },

    {
        key: 'm_pozitivno_temp',
        translationKey: 'm_pozitivno_temp'
    },

    {
        key: 'm_negativno',
        translationKey: 'm_negativno'
    },

    {
        key: 'm_negativno_temp',
        translationKey: 'm_negativno_temp'
    },

    // n GROUP

    {
        translationKey: 'n_group',
        isGroup: true
    },

    {
        key: 'n_u_polju',
        translationKey: 'n_u_polju'
    },

    {
        key: 'n_u_polju_temp',
        translationKey: 'n_u_polju_temp'
    },

    {
        key: 'n_srednji_oslonac',
        translationKey: 'n_srednji_oslonac'
    },

    {
        key: 'n_srednji_oslonac_temp',
        translationKey: 'n_srednji_oslonac_temp'
    },

    // o GROUP

    {
        translationKey: 'o_group',
        isGroup: true
    },

    {
        key: 'o_u_polju',
        translationKey: 'o_u_polju'
    },

    {
        key: 'o_srednji_oslonac',
        translationKey: 'o_srednji_oslonac'
    },

    // IX–XVI

    {
        key: 'ix_pozar',
        translationKey: 'ix_pozar'
    },

    {
        key: 'x_voda',
        translationKey: 'x_voda'
    },

    {
        key: 'xi_zrak',
        translationKey: 'xi_zrak'
    },

    {
        key: 'xii_para',
        translationKey: 'xii_para'
    },

    {
        key: 'xiii_zvuk',
        translationKey: 'xiii_zvuk'
    },

    {
        key: 'xiv_apsorpcija',
        translationKey: 'xiv_apsorpcija'
    },

    {
        key: 'xv_trajnost',
        translationKey: 'xv_trajnost'
    },

    {
        key: 'xvi_test',
        translationKey: 'xvi_test'
    },

    {
        key: 'dokumentacija',
        translationKey: 'dokumentacija'
    }

]

export const STANDARD_OPTIONS = [
    { value: 'NPD', label: 'Nije definisano' },
    { value: 'EN_14509', label: 'EN 14509' },
    { value: 'EN_13501_2', label: 'EN 13501-2' },
    { value: 'EN_10169', label: 'EN 10169' }
];

export const USKLADJENI_STANDARDI = [
    { value: 'EN_14509_2014', label: 'BAS EN 14509:2014' },
    { value: 'EN_13165', label: 'BAS EN 13165' }
];

export const OTPORNOST = {
    enabled: ['Odaberi','Da', 'Ne'],
    type: ['REI', 'EI'],
    minutes: [15,20,30,45,60,90,120,150,180,240]
};

export const DEBLJINE_LIM = [0.30,0.35,0.40,0.45,0.50,0.55,0.60,0.65,0.70];

export const KARAKTERISTIKE_13165 = [

    // BASIC

    {
        key: 'toplotna_otpornost',
        translationKey: 'toplotna_otpornost'
    },

    {
        key: 'toplotna_provodljivost',
        translationKey: 'toplotna_provodljivost'
    },

    // V

    {
        translationKey: 'tolerancije_debljine_group',
        isGroup: true
    },

    {
        key: 'kategorija_tolerancije',
        translationKey: 'kategorija_tolerancije',
        type: 'select',
        options: ['T0', 'T1', 'T2', 'T3']
    },

    {
        key: 'plus_tolerancija',
        translationKey: 'plus_tolerancija'
    },

    {
        key: 'minus_tolerancija',
        translationKey: 'minus_tolerancija'
    },

    // VI

    {
        translationKey: 'reakcija_na_vatru_group',
        isGroup: true
    },

    {
        key: 'performance',
        translationKey: 'performance_class',
        type: 'select',
        options: DOP_CONFIG.performanceClass
    },

    {
        key: 'smoke',
        translationKey: 'smoke_classification',
        type: 'select',
        options: DOP_CONFIG.smoke
    },

    {
        key: 'droplets',
        translationKey: 'flaming_droplets',
        type: 'select',
        options: DOP_CONFIG.droplets
    },

    // VIII

    {
        translationKey: 'izdrzljivost_group',
        isGroup: true
    },

    {
        key: 'dimenzionalna_stabilnost',
        translationKey: 'dimenzionalna_stabilnost',
        type: 'select',
        options: ['DS(70,-) 4', 'NPD']
    },

    {
        key: 'deformacija',
        translationKey: 'deformacija_pod_opterecenjem',
        type: 'select',
        options: ['DLT(1)5', 'NPD']
    },

    // IX

    {
        key: 'pritisak',
        translationKey: 'cvrstoca_na_pritisak'
    },

    // X

    {
        key: 'zatezanje',
        translationKey: 'cvrstoca_na_zatezanje',
        type: 'select',
        options: ['NPD', 'TR50', 'TR40']
    },

    // XII

    {
        translationKey: 'vodopropusnost_group',
        isGroup: true
    },

    {
        key: 'kratkotrajna_voda',
        translationKey: 'kratkotrajna_apsorpcija_vode'
    },

    {
        key: 'dugotrajna_djelimicna',
        translationKey: 'dugotrajna_djelimicna_apsorpcija'
    },

    {
        key: 'dugotrajna_potpuna',
        translationKey: 'dugotrajna_potpuna_apsorpcija'
    },

    {
        key: 'ravnost',
        translationKey: 'ravnost_nakon_kvasenja',
        type: 'select',
        options: ['FW2', 'NPD']
    },

    // FINAL

    {
        key: 'paropropusnost',
        translationKey: 'paropropusnost'
    },

    {
        key: 'zvuk',
        translationKey: 'indeks_apsorpcije_zvuka'
    },

    {
        key: 'opasne_materije',
        translationKey: 'ispustanje_opasnih_materija'
    },

    {
        key: 'izgaranje',
        translationKey: 'kontinuirano_uzareno_izgaranje'
    }

];

export const PROIZVODJACI = [
    {
        value: 'Alternativa d.o.o, Put Famosa 38, 71212 Hrasnica - Sarajevo, Bosna i Hercegovina',
        label: 'Alternativa d.o.o, Put Famosa 38, 71212 Hrasnica - Sarajevo, Bosna i Hercegovina',
    },
    {
        value: 'Alternativa d.o.o, Donja Zimča bb, 71300 Visoko, Bosna i Hercegovina',
        label: 'Alternativa d.o.o, Donja Zimča bb, 71300 Visoko, Bosna i Hercegovina',
    },
];

export const IZVOR_MEHANICKI_SVOJSTAVA = [
    {
        value: 'DIBT(Njemačka)',
        label: 'DIBT(Njemačka)',
    },
    {
        value: 'GIT (BiH)',
        label: 'GIT (BiH)',
    },
];